import {required} from "vuelidate/lib/validators";

export class Municipality {
    constructor(initObjectParams) {
        this.id = null;
        this.name = null;
        this.shortName = null;
        this.eliminated = null;
        this.parent = null;
        this.parentObject = {};
        this.parentName = null;
        this.listOrder = 0
    }
    
    static get modelName() {
        return 'Municipality'
    }

    static get validations() {
        return {
            name: { required },
            shortName: { required },
            eliminated: {},
            parent: {},
            listOrder: {}
        }
    }

    static get validationFieldLabels() {
        return {
            name: 'Название',
            shortName: 'Краткое название',
            eliminated: 'Упразднен',
            parent: 'Вышестоящий муниципалитет',
            listOrder: 'Порядковый номер'
        }
    }

    static get mapping() {
        return {
            shortName: 'short_name'
        }
    }

    static get label() {
        return 'Муниципалитет'
    }

    label() {
        return 'Муниципалитет'
    }

    static get newLabel() {
        return 'Новый муниципалитет'
    }

    objectLabel() {
        return `${this.shortName}`
    }

    applyData(data) {
        this.id = data['id'];
        this.name = data['name'];
        this.shortName = data['short_name'];
        this.eliminated = data['eliminated'];
        this.parent = data['parent'];
        this.parentName = data['parent_name'];
        this.parentObject = data['parent_object']
        this.listOrder = data['list_order']
    }
    
}